module.exports = __webpack_public_path__ + "static/media/Pic-0085.6336483f.jpg";